/*
 * カウントダウンタイマー
 */
// カウントダウンの目標日付を設定します
var targetDate = new Date("Dec 22, 2024 23:59:59").getTime();

// 1秒ごとに更新されるタイマーを設定します
var countdown = setInterval(function () {
  var now = new Date().getTime();
  var distance = targetDate - now;

  // 日、時間、分、秒を計算します
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // カウントダウンタイマーを表示します
  document.getElementById("countdown").innerHTML = document.getElementById("countdown").innerHTML =
    '<span class="limit">あと</span>' + "<span class='countdown-item'>" + days + '</span><span class="times">日</span>  ' + "<span class='countdown-item'>" + hours + '</span><span class="times">時間</span>' + "<span class='countdown-item'>" + minutes + '</span><span class="times">分</span>' + "<span class='countdown-item'>" + seconds + '</span><span class="times">秒</span>';

  // ターゲット日に達した場合、メッセージを表示してタイマーを停止します
  if (distance < 0) {
    clearInterval(countdown);
    document.getElementById("countdown").innerHTML = "予約受付は終了しました";
  }
}, 1000);

/*
 * 数量変更ボタン
 */
document.addEventListener("DOMContentLoaded", function () {
  const decreaseButtons = document.querySelectorAll('#section-xmas2023-product-a [data-action="decrease-quantity"], #section-xmas2023-product-b [data-action="decrease-quantity"],#section-xmas2023-product-c [data-action="decrease-quantity"],#section-xmas2023-productlist2 [data-action="decrease-quantity"] ');
  const increaseButtons = document.querySelectorAll('#section-xmas2023-product-a [data-action="increase-quantity"], #section-xmas2023-product-b [data-action="increase-quantity"], #section-xmas2023-product-c [data-action="increase-quantity"], #section-xmas2023-productlist2 [data-action="increase-quantity"]');
  const quantityInputs = document.querySelectorAll("#section-xmas2023-product-a .QuantitySelector__CurrentQuantity, #section-xmas2023-product-b .QuantitySelector__CurrentQuantity, #section-xmas2023-product-c .QuantitySelector__CurrentQuantity, #section-xmas2023-productlist2 .QuantitySelector__CurrentQuantity");

  decreaseButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      let currentQuantity = parseInt(button.parentElement.querySelector(".QuantitySelector__CurrentQuantity").value);
      if (currentQuantity > 1) {
        button.parentElement.querySelector(".QuantitySelector__CurrentQuantity").value = currentQuantity - 1;
      }
    });
  });

  increaseButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      let currentQuantity = parseInt(button.parentElement.querySelector(".QuantitySelector__CurrentQuantity").value);
      button.parentElement.querySelector(".QuantitySelector__CurrentQuantity").value = currentQuantity + 1;
    });
  });
});

//アンカーリンクを付与
document.addEventListener("DOMContentLoaded", function() {
    const featuredProducts = document.querySelectorAll('.shopify-section--featured-product');
    let counter = 1;

    featuredProducts.forEach((element) => {
        const sectionSpacing = element.querySelector('.section-spacing');

        if (sectionSpacing) {
            sectionSpacing.id = `section-spacing-${counter}`;
            counter++;
        }
    });
});


